import apiEndpoints from 'const/apiEndpoints'
import config from 'const/config'
import routes from 'const/routes'
import clearSessionStorage from 'helpers/clearSessionStorage'

import { defaultDataSubjectParams } from './getDataSubjectParams'
import handleRevokeAccessToken from './handleRevokeAccessToken'
import redirectToUrl from './redirectToUrl'

const handleLogout = async (
  postLogoutRedirectUri?: string,
  intcmpValue?: string
): Promise<void> => {
  const correlationId = sessionStorage.getItem('correlationId')
  const dataSubjectParams =
    window.OneTrust?.dataSubjectParams ?? defaultDataSubjectParams

  await handleRevokeAccessToken()
  clearSessionStorage()

  sessionStorage.setItem(correlationId, JSON.stringify(dataSubjectParams))
  if (intcmpValue) sessionStorage.setItem('intcmp', intcmpValue)

  const defaultRedirectUri = `${window.location.origin}${config.BASENAME}${routes.LOGOUT}`
  const encodedRedirectUri = postLogoutRedirectUri
    ? encodeURIComponent(postLogoutRedirectUri)
    : defaultRedirectUri
  redirectToUrl(
    `${config.AUTH_DOMAIN}${apiEndpoints.LOGOUT}?post_logout_redirect_uri=${encodedRedirectUri}`
  )
}

export default handleLogout
